// Generate code from clean architecture template

import { CourseEntity } from '../entities';
import { CoursePayloadForm } from '../ports/payloads';
import { CourseRepository } from '../ports/repositories';

export class CreateCourseUsecase {
  constructor(private readonly repo: CourseRepository) {}

  async run(payload: CoursePayloadForm): Promise<CourseEntity> {
    const data = await this.repo.createCourse(payload);
    return data;
  }
}
